module.exports = __webpack_public_path__ + "img/k3.6b0e762a.png";